export type TWebShareResult = 'shared' | 'dismissed' | 'unsupported' | 'error'

export const shareViaWebShare = async (
	data: ShareData,
): Promise<TWebShareResult> => {
	if (
		typeof navigator === 'undefined' ||
		typeof navigator.share !== 'function'
	) {
		return 'unsupported'
	}

	try {
		await navigator.share(data)
		return 'shared'
	} catch (error) {
		const name = (error as { name?: string } | null)?.name

		if (name === 'AbortError' || name === 'NotAllowedError') {
			return 'dismissed'
		}
		return 'error'
	}
}
